'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Fetch credentials options

exports.default = ['omit', 'same-origin', 'include'];